import axios from '../utils/axios';

export default function fetchJobAssignees(adminId, params) {
    return (
        axios.get('/admin/' + adminId + '/job-assignees', {
            params: params
        })
            .then(res => {
                return res.data
            })
            .catch(err => {
                return err;
            })
    )
}
